export const GET_PROFILE_REQUEST = 'GET_PROFILE_REQUEST';
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';
export const GET_PROFILE_FAIL = 'GET_PROFILE_FAIL';
export const SET_PROFILE_MEASUREMENT_FORMAT = 'SET_PROFILE_MEASUREMENT_FORMAT';
